import React from 'react'
import { slugs } from '@/constants/slugs'
import { CustomImageBanner } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/CustomImageBanner'
import { EarlyBirdBanner } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/EarlyBirdBanner/EarlyBirdBanner'
import { NoFeesBanner } from '@/views/TicketCheckoutViews/ShowtimesView/components/banners/NoFeesBanner/NoFeesBanner'
import { useTheatricalPromotionContext } from '@/views/TicketCheckoutViews/components/TheatricalPromotionContext'
import { getCustomCodeComponent } from '@/views/TicketCheckoutViews/components/TheatricalPromotionContext/utils'
import { GiveawayBanner } from '../GiveawayBanners/GiveawayBanner'
import { GuildTicketsBanner } from '../GuildTicketsBanner'
import { DavidNoFeesBanner } from '../NoFeesBanner/DavidNoFeesBanner'

export interface TicketPromoBannerProps {
  theatricalSlug: string
  projectName: string
}

export const TicketPromoBanners: React.FC<TicketPromoBannerProps> = ({ theatricalSlug, projectName }) => {
  const { promo, refetchPublicDiscounts } = useTheatricalPromotionContext()

  if (!promo) return null

  const { banner } = promo

  const renderContent = () => {
    switch (banner?.bannerType) {
      case 'giveaway':
        return <GiveawayBanner theatricalSlug={theatricalSlug} />
      case 'early_bird':
        if (promo.promoType !== 'early_bird') return null
        return (
          <EarlyBirdBanner
            backgroundImage={banner.backgroundImage}
            foregroundImage={banner.foregroundImage}
            accentColor={banner.accentColor}
            code={promo.publicDiscount.code}
            openingWeek={banner.openingWeek}
            earlyBirdDiscount={promo.publicDiscount}
            refetch={refetchPublicDiscounts}
          />
        )
      case 'premium_guild':
        return (
          <GuildTicketsBanner
            theatricalSlug={theatricalSlug}
            projectName={projectName}
            className="overflow-hidden rounded-xl"
          />
        )
      case 'no_fees':
        if (promo.promoType !== 'no_fees') return null
        return theatricalSlug === slugs.david ? (
          <DavidNoFeesBanner
            backgroundImage={banner.backgroundImage}
            foregroundImage={banner.foregroundImage}
            accentColor={banner.accentColor}
            code={promo.publicDiscount.code}
            backgroundIsDark={![slugs.david, slugs.iWasAStranger].includes(theatricalSlug)}
          />
        ) : (
          <NoFeesBanner
            backgroundImage={banner.backgroundImage}
            foregroundImage={banner.foregroundImage}
            accentColor={banner.accentColor}
            code={promo.publicDiscount.code}
            noFeesDiscount={promo.publicDiscount}
            backgroundIsDark={![slugs.david, slugs.iWasAStranger].includes(theatricalSlug)}
          />
        )

      case 'custom_image':
        return <CustomImageBanner {...banner} alt={`${promo.code} banner`} />
      case 'custom_code': {
        const customCodeComponent = getCustomCodeComponent(banner.name)
        return typeof customCodeComponent === 'function' ? null : customCodeComponent
      }
      default:
        return null
    }
  }
  return renderContent()
}
